module.exports = __webpack_public_path__ + "img/drving-license@2x.6f167dd6.png";